/** Raydium launchpad: "Symbol length should shorter than 11" → max 10 characters. */
export const LAUNCHLAB_MAX_SYMBOL_LENGTH = 10;

export const LAUNCHLAB_SYMBOL_TOO_LONG_MESSAGE = `Symbol must be ${LAUNCHLAB_MAX_SYMBOL_LENGTH} characters or fewer.`;

/**
 * Uppercase and cap to the on-chain Launchlab symbol limit.
 * @param {unknown} value
 * @returns {string}
 */
export function sanitizeLaunchlabSymbol(value) {
  const raw = typeof value === "string" ? value : "";
  return raw.toUpperCase().slice(0, LAUNCHLAB_MAX_SYMBOL_LENGTH);
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidLaunchlabSymbol(value) {
  const symbol = typeof value === "string" ? value.trim() : "";
  return symbol.length >= 1 && symbol.length <= LAUNCHLAB_MAX_SYMBOL_LENGTH;
}
